if (!customElements.get('sale-countdown')) {
  class SaleCountdown extends HTMLElement {
    connectedCallback() {
      // Parse the timestamp (the 'Z' ensures UTC processing)
      this.endDate = new Date(this.getAttribute('data-end')).getTime();
      this.label = this.getAttribute('data-label');
      
      this.update();
      this.interval = setInterval(() => this.update(), 1000);
    }

    // Crucial for AJAX carts: Prevents memory leaks by destroying the interval 
    // when the theme replaces the cart HTML
    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }

    update() {
      const now = new Date().getTime();
      const dist = this.endDate - now;

      // Stop timer and hide if the sale has ended
      if (dist < 0) { 
        this.style.display = 'none'; 
        if (this.interval) clearInterval(this.interval);
        return; 
      }
      
      this.style.display = 'block';
      const d = Math.floor(dist / 86400000);
      const h = Math.floor((dist % 86400000) / 3600000);
      const m = Math.floor((dist % 3600000) / 60000);
      const s = Math.floor((dist % 60000) / 1000);
      
      this.innerHTML = `<div class="timer-wrapper"><span>${this.label}</span><span class="timer-display">${d}d ${h}h ${m}m ${s}s</span></div>`;
    }
  }
  
  customElements.define('sale-countdown', SaleCountdown);
}